import * as z from "zod";

const OverboxServiceSchema = z.enum(["apc", "epg"]);
const OverboxCarrierSchema = z.enum(["fedex", "ups", "dhl"]);

export const getOverboxConfig = {
  name: "getOverboxConfig" as const,
  input: z.object({}),
  output: z.object({
    services: z.array(
      z.object({
        id: OverboxServiceSchema,
        label: z.string(),
        fulfillmentCenter: z
          .object({ id: z.string(), label: z.string() })
          .nullable(),
        carriers: z.array(
          z.object({ id: OverboxCarrierSchema, label: z.string() }),
        ),
      }),
    ),
  }),
};
